export const devMode = import.meta.env.DEV
export const orgId = import.meta.env.VITE_FULLSTORY_ORG_ID
export const dsn = import.meta.env.VITE_SENTRY_DSN
export const sentryOrg = import.meta.env.VITE_SENTRY_ORG_SLUG
export const root = import.meta.env.BASE_URL
